<template lang="pug">
modal(name='login', transition='pop-up', :width='modalWidth', height='auto')
  .box(:style="`height:${displayMap.height}px`")
    #bp-left.box-part
      #auth()
        amplify-sign-in(v-if='displayMap.showSignIn' v-bind:sign-in-config='options.signInConfig')
        amplify-sign-up(v-if='displayMap.showSignUp' v-bind:sign-up-config='options.signUpConfig')
        amplify-confirm-sign-up(v-if='displayMap.showConfirmSignUp' v-bind:confirm-sign-up-config='options.confirmSignUpConfig')
        amplify-confirm-sign-in(v-if='displayMap.showConfirmSignIn' v-bind:confirm-sign-in-config='options.confirmSignInConfig')
        amplify-forgot-password(v-if='displayMap.showForgotPassword' v-bind:forgot-password-config='options.forgotPasswordConfig')
        amplify-require-new-password(v-if='displayMap.requireNewPassword' v-bind:require-newpassword-config='options.requireNewPasswordConfig')
        amplify-set-mfa(v-if='displayMap.showMfa' v-bind:mfa-config='options.mfaConfig')
    #bp-right.box-part
      .box-messages
</template>
<script>
const MODAL_WIDTH = 656

export default {
  name: 'LoginModal',
  data () {
    return {
      modalWidth: MODAL_WIDTH,
			displayMap: { height: 402 }
    }
  },
  computed: {
    height() { return this.displayMap.height },
    options() {
      const defaults = {
        signInConfig: {},
        signUpConfig: {},
        confirmSignUpConfig: {},
        confirmSignInConfig: {},
        forgotPasswordConfig: {},
        mfaConfig: {},
        requireNewPasswordConfig: {}
      };
      return Object.assign(defaults, this.authConfig || {})
    }
  },
methods: {
    updateDisplayMap: state => {
      return {
        showSignIn: state === 'signedOut' || state === 'signIn',
        showSignUp: state === 'signUp',
        showConfirmSignUp: state === 'confirmSignUp',
        showConfirmSignIn: state === 'confirmSignIn',
        showForgotPassword: state === 'forgotPassword',
        showSignOut: state === 'signedIn',
        showMfa: state === 'setMfa',
        requireNewPassword: state === 'requireNewPassword',
        height: state === 'signUp' ? 558 : state === 'forgotPassword' ? 298 :  402
      }
    }
          },
  created () {
    this.$eventBus.$on('authState', data => {
      this.displayMap = this.updateDisplayMap(data)
    });
		this.$eventBus.$on('localUser', user => {
      this.user = user;
      this.options.signInConfig.username = this.user.username;
      this.options.confirmSignInConfig.user = this.user;
      this.options.confirmSignUpConfig.username = this.user.username;
      this.options.requireNewPasswordConfig.user = this.user;
    });
    this.modalWidth = window.innerWidth < MODAL_WIDTH
      ? MODAL_WIDTH / 2
      : MODAL_WIDTH
  }
}
</script>
<style lang="scss">
  .box #bp-right .logo {
          background: url(/img/whitelogo.png) no-repeat center center;
              background-size: 128px;
                  width: 100%;
                      height: 100%;
    }

#auth div.error {
right: -150px;
    position: absolute;
    top: 5%;
    width: 250px;
    height: 30px;
    font-weight: 600;
    color: white;
    font-size: 16px;
    z-index: 99999;
}
.box {
transition: height 0.3s;
}
#auth .Button__button___1FrBC {
}
#authspinner {
position: absolute;
top: 42%;
left: 42%;
}
#auth {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#auth > div > div {
margin-top: 0px;
transition: margin-top 0.5s;
}

#auth * {
box-shadow: none !important;
}
#auth button {
background-color: #f96332;
color: white;
}
$background_color: #404142;
$github_color: #DBA226;
$facebook_color: #3880FF;

.box {
  background: white;
  overflow: hidden;
  width: 656px;
  border-radius: 2px;
  box-sizing: border-box;
  box-shadow: 0 0 40px black;
  color: #8b8c8d;
  font-size: 0;

  .box-part {
    display: inline-block;
    position: relative;
    vertical-align: top;
    box-sizing: border-box;
    height: 100%;
    width: 50%;

    &#bp-right {
      background: url("/img/slide1.jpg") no-repeat top center;
      border-left: 1px solid #eee;
      background-size: cover;
      background-color: #02385f;
    }
  }

#auth > div > div[data-test="sign-in-section"] {
  margin-top: 0px;
  transition: margin-top 0.5s;
  }
#auth > div > div[data-test="sign-up-section"] {
  margin-top: 0px;
  transition: margin-top 0.5s;
  }

  .box-messages {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
  }

  .box-error-message {
    position: relative;
    overflow: hidden;
    box-sizing: border-box;

    height: 0;
    line-height: 32px;
    padding: 0 12px;
    text-align: center;
    width: 100%;
    font-size: 11px;
    color: white;
    background: #F38181;
  }

  .partition {
    width: 100%;
    height: 100%;

    .partition-title {
      box-sizing: border-box;
      padding: 30px;
      width: 100%;
      text-align: center;
      letter-spacing: 1px;
      font-size: 20px;
      font-weight: 300;
    }

    .partition-form {
      padding: 0 20px;
      box-sizing: border-box;
    }
  }

  input[type=password],
  input[type=text] {
    display: block;
    box-sizing: border-box;
    margin-bottom: 4px;
    width: 100%;
    font-size: 12px;
    line-height: 2;
    border: 0;
    border-bottom: 1px solid #DDDEDF;
    padding: 4px 8px;
    font-family: inherit;
    transition: 0.5s all;
    outline: none;
  }

  button {
    background: white;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 10px;
    letter-spacing: 1px;
    font-family: "Open Sans", sans-serif;
    font-weight: 400;
    min-width: 140px;
    margin-top: 8px;
    color: #8b8c8d;
    cursor: pointer;
    border: 1px solid #DDDEDF;
    text-transform: uppercase;
    transition: 0.1s all;
    font-size: 10px;
    outline: none;
    &:hover {
      border-color: mix(#DDDEDF, black, 90%);
      color: mix(#8b8c8d, black, 80%);
    }
  }

  .large-btn {
    width: 100%;
    background: white;

    span {
      font-weight: 600;
    }
    &:hover {
      color: white !important;
    }
  }

  .button-set {
    margin-bottom: 8px;
  }

  #register-btn,
  #signin-btn {
    margin-left: 8px;
  }

  .facebook-btn {
    border-color: $facebook_color;
    color: $facebook_color;
    &:hover {
      border-color: $facebook_color;
      background: $facebook_color;
    }
  }

  .github-btn {
    border-color: $github_color;
    color: $github_color;
    &:hover {
      border-color: $github_color;
      background: $github_color;
    }
  }

  .autocomplete-fix {
    position: absolute;
    visibility: hidden;
    overflow: hidden;
    opacity: 0;
    width: 0;
    height: 0;
    left: 0;
    top: 0;
  }
}

.pop-out-enter-active,
.pop-out-leave-active {
  transition: all 0.5s;
}

.pop-out-enter,
.pop-out-leave-active {
  opacity: 0;
  transform: translateY(24px);
}
a.nav-link.btn.btn-auth.login {
position: relative;
left: 20px;
bottom: 20px;
width: 100px;
}
</style>
